// extracted by mini-css-extract-plugin
module.exports = {"main-loader":"Spinner_main-loader__1Gjui","loader-container":"Spinner_loader-container__C-xOD","waitcls":"Spinner_waitcls__1vHoO"};